import { ContentData } from "@vp/models";

export class LoadGlobalAlerts {
  public static readonly type = "[System Banner] Load Global Alerts";
}

export class DismissAlert {
  public static readonly type = "[System Banner] Dismiss Alert";
  constructor(public alertId: string) {}
}

export class AddGlobalAlert {
  public static readonly type = "[System Banner] Add Global Alert";
  constructor(public alert: ContentData) {}
}
